import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getLanguage } from 'src/utils/data/i18n';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: {
        // eslint-disable-next-line no-undef
        translation: I18N_TRANSLATION_EN,
      },
      cn: {
        // eslint-disable-next-line no-undef
        translation: I18N_TRANSLATION_CN,
      },
      test: {
        // eslint-disable-next-line no-undef
        translation: I18N_TRANSLATION_TEST,
      },
    },
    lng: getLanguage(),
    fallbackLng: 'en',
    debug: true,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
